import { module } from "angular";
import Chartist, { ChartDrawData, IChartistSeriesData, ILineChartOptions, IPieChartOptions } from "chartist";
import { loadModuleStyles } from "@gtmhub/shared/ng-extensions/util";
import moduleStyles from "./chartist.module.less";
import "./plugins/chartist-plugin-tooltip.js";
import "./plugins/gtmhub-chartist-kr-rect-plugin.js";
import "./plugins/gtmhub-chartist-vertical-line-plugin.js";

export { Chartist, ILineChartOptions, IPieChartOptions, ChartDrawData, IChartistSeriesData };

const mod = module("gh-chartist", []);

loadModuleStyles(mod, moduleStyles);

export default mod.name;
